<!--===========================
=            LISTS            =
============================-->
<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Lists</div>
      </base-header>
    </v-row>
            <v-row>

                <v-col class="col-12 col-md-6 col-sm-12">

                    <base-card>
                        <div slot="card-header">
                            Dense
                        </div>
                        <div slot="card-subheader">v-list can be lowered with dense property.

                        </div>
                        <div slot="card-body">
                            <v-list dense>
                                <v-subheader>REPORTS</v-subheader>
                                <v-list-item-group v-model="selectedItem" color="primary">
                                    <v-list-item v-for="(item, i) in items" :key="i">
                                        <v-list-item-icon>
                                            <v-icon v-text="item.icon"></v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title v-text="item.text"></v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list-item-group>
                            </v-list>
                            <div style="height:50px;"></div>
                        </div>
                    </base-card>
                </v-col>
                <v-col class="col-12 col-md-6 col-sm-12">
                    <base-card>
                        <div slot="card-header">

                            Disabled </div>
                        <div slot="card-subheader">You cannot interact with disabled v-list.</div>
                        <div slot="card-body">
                            <v-list disabled>
                                <v-subheader>REPORTS</v-subheader>
                                <v-list-item-group v-model="selectedItem" color="primary">
                                    <v-list-item v-for="(item, i) in items" :key="i">
                                        <v-list-item-icon>
                                            <v-icon v-text="item.icon"></v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title v-text="item.text"></v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list-item-group>
                            </v-list>
                        </div>
                    </base-card>
                </v-col>

                <v-col class="col-12 col-md-6 col-sm-12">
                    <base-card>
                        <div slot="card-header">
                            Rounded
                        </div>
                        <div slot="card-subheader">Items don’t change when selected in v-list with flat property.

                        </div>
                        <div slot="card-body">
                            <v-list rounded>
                                <v-subheader>REPORTS</v-subheader>
                                <v-list-item-group v-model="selectedItem" color="primary">
                                    <v-list-item v-for="(item, i) in items" :key="i">
                                        <v-list-item-icon>
                                            <v-icon v-text="item.icon"></v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title v-text="item.text"></v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list-item-group>
                            </v-list>
                        </div>
                    </base-card>
                </v-col>

               
                <v-col class="col-12 col-md-6 col-sm-12">
                    <base-card>
                        <div slot="card-header">
                            Shaped
                        </div>
                        <div slot="card-subheader">Shaped lists have rounded borders on one side of the v-list-item.
                        </div>
                        <div slot="card-body">
                            <v-list shaped>
                                <v-subheader>REPORTS</v-subheader>
                                <v-list-item-group v-model="selectedItem" color="primary">
                                    <v-list-item v-for="(item, i) in items" :key="i">
                                        <v-list-item-icon>
                                            <v-icon v-text="item.icon"></v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title v-text="item.text"></v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list-item-group>
                            </v-list>
                        </div>
                    </base-card>
                </v-col>

                <v-col class="col-12 col-md-6 col-sm-12">

                    <base-card>
                        <div slot="card-header">
                            #Flat
                        </div>
                        <div slot="card-subheader">Items don’t change when selected in v-list with flat property.</div>
                        <div slot="card-body">
                            <v-list flat>
                                <v-subheader>REPORTS</v-subheader>
                                <v-list-item-group v-model="selectedItem" color="primary">
                                    <v-list-item v-for="(item, i) in items" :key="i">
                                        <v-list-item-icon>
                                            <v-icon v-text="item.icon"></v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title v-text="item.text"></v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list-item-group>
                            </v-list>
                        </div>
                    </base-card>
                </v-col>

                <v-col class="col-12 col-md-6 col-sm-12">
                    <base-card>
                        <div slot="card-header">
                            Two lines and subheader
                        </div>
                        <div slot="card-subheader">Lists can contain subheaders, dividers, and can contain 1 or more
                            lines. The subtitle will overflow with ellipsis if it extends past one line.</div>
                        <div slot="card-body">
                            <v-list flat subheader three-line>
                                <v-subheader>General</v-subheader>

                                <v-list-item-group v-model="settings" multiple active-class="">
                                    <v-list-item>
                                        <template v-slot:default="{ active }">
                                            <v-list-item-action>
                                                <v-checkbox :input-value="active"></v-checkbox>
                                            </v-list-item-action>

                                            <v-list-item-content>
                                                <v-list-item-title>Notifications</v-list-item-title>
                                                <v-list-item-subtitle>Notify me about updates to apps or games that I
                                                    downloaded</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </template>
                                    </v-list-item>

                                    <v-list-item>
                                        <template v-slot:default="{ active }">
                                            <v-list-item-action>
                                                <v-checkbox :input-value="active"></v-checkbox>
                                            </v-list-item-action>

                                            <v-list-item-content>
                                                <v-list-item-title>Sound</v-list-item-title>
                                                <v-list-item-subtitle>Auto-update apps at any time. Data charges may
                                                    apply
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                        </template>
                                    </v-list-item>


                                </v-list-item-group>
                            </v-list>
                        </div>
                    </base-card>
                </v-col>
                
            </v-row>

  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  export default {
    components: {
      BaseCard,
      BaseHeader
    },  data: () => ({
            settings: [],
            selectedItem: 1,
            items: [{
                    text: 'Real-Time',
                    icon: 'mdi-clock'
                },
                {
                    text: 'Audience',
                    icon: 'mdi-account'
                },
                {
                    text: 'Conversions',
                    icon: 'mdi-flag'
                },
            ],
            items1: [{
                    header: 'Today'
                },
                {
                    avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
                    title: 'Brunch this weekend?',
                    subtitle: `<span class="text--primary">Ali Connors</span> &mdash; I'll be in your neighborhood doing errands this weekend. Do you want to hang out?`,
                },
                {
                    divider: true,
                    inset: true
                },
                {
                    avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg',
                    title: 'Samam <span class="grey--text text--lighten-1">4</span>',
                    subtitle: `<span class="text--primary">to Alex, Scott, Jennifer</span> &mdash; Wish I could come, but I'm out of town this weekend.`,
                },
                {
                    avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg',
                    title: 'Summer BBQ <span class="grey--text text--lighten-1">4</span>',
                    subtitle: `<span class="text--primary">to Alex, Scott, Jennifer</span> &mdash; Wish I could come, but I'm out of town this weekend.`,
                },
            ],
            files: [{
                    color: 'blue',
                    icon: 'mdi-clipboard-text',
                    subtitle: 'Jan 20, 2014',
                    title: 'Vacation itinerary',
                },
                {
                    color: 'amber',
                    icon: 'mdi-gesture-tap-button',
                    subtitle: 'Jan 10, 2014',
                    title: 'Kitchen remodel',
                },
            ],
            folders: [{
                    subtitle: 'Jan 9, 2014',
                    title: 'Photos',
                },
                {
                    subtitle: 'Jan 17, 2014',
                    title: 'Recipes',
                },
                {
                    subtitle: 'Jan 28, 2014',
                    title: 'Work',
                },
            ],
            items2: [{
                    action: 'mdi-ticket',
                    items: [{
                        title: 'List Item'
                    }],
                    title: 'Attractions',
                },
                {
                    action: 'mdi-silverware-fork-knife',
                    active: true,
                    items: [{
                            title: 'Breakfast & brunch'
                        },
                        {
                            title: 'New American'
                        },
                        {
                            title: 'Sushi'
                        },
                    ],
                    title: 'Dining',
                },
                {
                    action: 'mdi-school',
                    items: [{
                        title: 'List Item'
                    }],
                    title: 'Education',
                },
                {
                    action: 'mdi-human-male-female-child',
                    items: [{
                        title: 'List Item'
                    }],
                    title: 'Family',
                },
                {
                    action: 'mdi-bottle-tonic-plus',
                    items: [{
                        title: 'List Item'
                    }],
                    title: 'Health',
                },

            ],
            admins: [
                ['Management', 'mdi-account-multiple-outline'],
                ['Settings', 'mdi-cog-outline'],
            ],
            cruds: [
                ['Create', 'mdi-plus-outline'],
                ['Read', 'mdi-file-outline'],
                ['Update', 'mdi-update'],
                ['Delete', 'mdi-delete'],
            ],
            selected2: [2],
            items3: [{
                    action: '15 min',
                    headline: 'Brunch this weekend?',
                    subtitle: `I'll be in your neighborhood doing errands this weekend. Do you want to hang out?`,
                    title: 'Ali Connors',
                },
                {
                    action: '2 hr',
                    headline: 'sasa BBQ',
                    subtitle: `Wish I could come, but I'm out of town this weekend.`,
                    title: 'me, Scrott, Jennifer',
                },
                {
                    action: '6 hr',
                    headline: 'Oui oui',
                    subtitle: 'Do you have Paris recommendations? Have you ever been?',
                    title: 'Sandra Adams',
                },
                {
                    action: '12 hr',
                    headline: 'Birthday gift',
                    subtitle: 'Have any ideas about what we should get Heidi for her birthday?',
                    title: 'Trevor Hansen',
                },
                {
                    action: '18hr',
                    headline: 'Recipe to try',
                    subtitle: 'We should eat this: Grate, Squash, Corn, and tomatillo Tacos.',
                    title: 'Britta Holt',
                },
            ],

        }),
    
  }
</script>


<!--====  End of LISTS  ====-->
